// extracted by mini-css-extract-plugin
export default {"checkbox__item":"styles_checkbox__item__WE1OA","checkbox":"styles_checkbox__phyYF","checked":"styles_checked__VXqcG"};